var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Expand",
    transform: "translate(-10.000000, -10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.17,18.1700167 C17.435803,18.1715368 17.6912812,18.0671865 17.88,17.88 C18.0693127,17.6922334 18.1757983,17.4366375 18.1757983,17.17 C18.1757983,16.9033625 18.0693127,16.6477666 17.88,16.46 L13.41,12 L15,12 C15.5522847,12 16,11.5522847 16,11 C16,10.4477153 15.5522847,10 15,10 L11,10 C10.8693227,10.00158 10.7402223,10.028759 10.62,10.08 C10.3756507,10.1814749 10.1814749,10.3756507 10.08,10.62 C10.028759,10.7402223 10.00158,10.8693227 10,11 L10,15 C10,15.5522847 10.4477153,16 11,16 C11.5522847,16 12,15.5522847 12,15 L12,13.41 L16.46,17.88 C16.6487188,18.0671865 16.904197,18.1715368 17.17,18.1700167 Z M23.54,16.46 C23.3522334,16.2706873 23.0966375,16.1642017 22.83,16.1642017 C22.5633625,16.1642017 22.3077666,16.2706873 22.12,16.46 L16.46,22.12 C16.2706873,22.3077666 16.1642017,22.5633625 16.1642017,22.83 C16.1642017,23.0966375 16.2706873,23.3522334 16.46,23.54 C16.6487188,23.7271865 16.904197,23.8315368 17.17,23.8300167 C17.435803,23.8315368 17.6912812,23.7271865 17.88,23.54 L23.54,17.88 C23.7293127,17.6922334 23.8357983,17.4366375 23.8357983,17.17 C23.8357983,16.9033625 23.7293127,16.6477666 23.54,16.46 Z M29,24 C28.4477153,24 28,24.4477153 28,25 L28,26.59 L23.54,22.12 C23.1478778,21.7278778 22.5121222,21.7278778 22.12,22.12 C21.7278778,22.5121222 21.7278778,23.1478778 22.12,23.54 L26.59,28 L25,28 C24.4477153,28 24,28.4477153 24,29 C24,29.5522847 24.4477153,30 25,30 L29,30 C29.1306773,29.99842 29.2597777,29.971241 29.38,29.92 C29.6243493,29.8185251 29.8185251,29.6243493 29.92,29.38 C29.971241,29.2597777 29.99842,29.1306773 30,29 L30,25 C30,24.4477153 29.5522847,24 29,24 Z",
    id: "Expand"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.4b659daee249ff956f17f7f5beb0d844.svg";
export { ForwardRef as ReactComponent };